import { getDefaultExportFromCjs as r } from "./index.es152.js";
import { __require as o } from "./index.es221.js";
var t = o();
const a = /* @__PURE__ */ r(t);
export {
  a as default
};
//# sourceMappingURL=index.es159.js.map
